if (!customElements.get("m-countdown-timer")) {
  if (!customElements.get("m-countdown-timer")) {
    class MCountdownTimer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.dataset.countdownMode === "rolling-daily") {
          this.initRollingDailyCountdown();
          return;
        }

        const time = this.dataset.time;
        const endTime = Date.parse(time.split(" ").join("T"));
        if (endTime) {
          new CountdownTimer(this, Date.now(), endTime);

          if (endTime > Date.now()) {
            this.classList.remove("hidden");
            this.classList.remove("m:hidden");
          }
        }
      }

      disconnectedCallback() {
        if (this.rollingDailyTimer) {
          clearInterval(this.rollingDailyTimer);
          this.rollingDailyTimer = null;
        }
      }

      initRollingDailyCountdown() {
        const days = Number(this.dataset.countdownDurationDays || 1);
        const duration = Math.max(days, 1) * 24 * 60 * 60 * 1000;
        const storageKey = this.dataset.countdownStorageKey || "minimog:rolling-daily-countdown";
        const selectors = {
          day: ".countdown-timer-day",
          hour: ".countdown-timer-hour",
          min: ".countdown-timer-minute",
          sec: ".countdown-timer-sec",
        };
        const nodes = {
          day: this.querySelector(selectors.day),
          hour: this.querySelector(selectors.hour),
          min: this.querySelector(selectors.min),
          sec: this.querySelector(selectors.sec),
        };
        const pad = (value) => String(value).padStart(2, "0");
        const readEndTime = () => {
          try {
            return Number(window.localStorage.getItem(storageKey));
          } catch (error) {
            return 0;
          }
        };
        const saveEndTime = (value) => {
          try {
            window.localStorage.setItem(storageKey, String(value));
          } catch (error) {
            // Browsers can block storage; the countdown still works for this page view.
          }
        };
        const resolveEndTime = () => {
          const now = Date.now();
          let endTime = readEndTime();
          const maxValidEndTime = now + duration + 5000;

          if (!endTime || endTime <= now || endTime > maxValidEndTime) {
            endTime = now + duration;
            saveEndTime(endTime);
          }

          return endTime;
        };
        let endTime = resolveEndTime();
        const render = () => {
          const now = Date.now();

          if (now >= endTime) {
            endTime = now + duration;
            saveEndTime(endTime);
          }

          const totalSeconds = Math.ceil(Math.max(endTime - now, 0) / 1000);
          const daysLeft = Math.floor(totalSeconds / (24 * 60 * 60));
          const hoursLeft = Math.floor(totalSeconds / (60 * 60)) % 24;
          const minutesLeft = Math.floor(totalSeconds / 60) % 60;
          const secondsLeft = totalSeconds % 60;

          if (nodes.day) nodes.day.textContent = pad(daysLeft);
          if (nodes.hour) nodes.hour.textContent = pad(hoursLeft);
          if (nodes.min) nodes.min.textContent = pad(minutesLeft);
          if (nodes.sec) nodes.sec.textContent = pad(secondsLeft);
          this.style.removeProperty("opacity");
          this.classList.remove("hidden");
          this.classList.remove("m:hidden");
        };

        render();
        this.rollingDailyTimer = setInterval(render, 1000);
      }
    }

    customElements.define("m-countdown-timer", MCountdownTimer);
  }
}
